import { render, staticRenderFns } from "./ProjectModal.vue?vue&type=template&id=e2eb0456&scoped=true&"
import script from "./ProjectModal.vue?vue&type=script&lang=js&"
export * from "./ProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectModal.vue?vue&type=style&index=0&id=e2eb0456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2eb0456",
  null
  
)

export default component.exports